import { createSlice } from '@reduxjs/toolkit';

export const recommendItems = createSlice({
  name: 'recommendItems',
  initialState: {
    data: [],
  },

  reducers: {
    setRecommendItems: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setRecommendItems } = recommendItems.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.isLoading`
export const getRecommendItems = (state) => state.recommendItems.data;

export default recommendItems.reducer;
